export const CATEGORY_HEADER_PREFIX = '## ';

export type MultiSelectDisplayRow =
  | { kind: 'header'; label: string }
  | { kind: 'option'; label: string; selected: boolean };

export function isCategoryHeaderOption(answerOption: string): boolean {
  return answerOption.startsWith(CATEGORY_HEADER_PREFIX);
}

export function stripCategoryHeaderPrefix(answerOption: string): string {
  return answerOption.slice(CATEGORY_HEADER_PREFIX.length);
}

/**
 * Builds completed / preview rows for a MultiSelect question.
 * Category headers (`## `) are labels only. Selected answers that are no
 * longer on the template still appear as checked rows.
 */
export function getMultiSelectDisplayRows(
  answerOptions: string[] | undefined,
  selectedAnswers: string[] | undefined,
): MultiSelectDisplayRow[] {
  const selected = selectedAnswers ?? [];
  const selectedSet = new Set(selected);
  const rows: MultiSelectDisplayRow[] = [];
  const seen = new Set<string>();

  (answerOptions ?? []).forEach((option) => {
    if (isCategoryHeaderOption(option)) {
      rows.push({
        kind: 'header',
        label: stripCategoryHeaderPrefix(option),
      });
      return;
    }

    seen.add(option);
    rows.push({
      kind: 'option',
      label: option,
      selected: selectedSet.has(option),
    });
  });

  selected.forEach((answer) => {
    if (!answer || seen.has(answer) || isCategoryHeaderOption(answer)) {
      return;
    }
    rows.push({ kind: 'option', label: answer, selected: true });
  });

  return rows;
}
